import {Component, Input} from '@angular/core';
import {CompanyImageResponse, CompanyResponse} from '../../../../../../@shared/models/response.module';
import {_COR_COY_6, _COR_COY_7} from '../../../../../../@shared/models/input.module';
import {CompanyService} from '../../../../../../@shared/services/company.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-company-images',
  standalone: false,
  templateUrl: './edit-company-images.html',
  styleUrl: './edit-company-images.css'
})
export class EditCompanyImages {
  @Input() company: CompanyResponse
  companyImages: CompanyImageResponse[]
  files: File[] = [];

  constructor(private companyService: CompanyService,
              private modal: NgbActiveModal) {
  }

  ngOnInit() {
    this.getCompanyImages();
  }

  getCompanyImages() {
    this.companyService.getCompanyImages({}).subscribe((res) => {
      this.companyImages = res;
    })
  }

  onFilesChanged(files: File[]) {
    console.log("Selected Files: ", files);
    this.files = files;
  }

  uploadImages() {
    for (let file of this.files) {
      let payload: _COR_COY_6 = {
        image: file
      }
      this.companyService.postCompanyImage(payload).subscribe((res) => {
        this.companyImages.push(res);
        console.log("Uploaded Image: ", res);
        this.modal.close(true)

      })
    }
  }

  deleteImage(image: CompanyImageResponse){
    let payload: _COR_COY_7 = {
      image_id: image.image_id
    }
    this.companyService.deleteCompanyImage(payload).subscribe((res) => {
      this.getCompanyImages()
    })
  }
}
